import ModalContent from '@components/modal/ModalContent';
import ModalTitle from '@components/modal/ModalTitle';
import { Trans } from '@lingui/macro';
import { Box, Button, Dialog } from '@mui/material';
import { FC, useState } from 'react';
import { CreateReportDialog } from './CreateReportDialog';
import { CreateReportTemplateDialog } from './CreateReportTemplateDialog';
import {
  FormFirstStepReportCreation,
  ReportCreationAttributes,
} from './FormFirstStepReportCreation';

interface Props {
  open: boolean;
  onClose: () => void;
  initialValues?: ReportCreationAttributes;
}

export const CreateReportDataExtractionDialog: FC<Props> = ({ open, onClose, initialValues }) => {
  const [openCreateTemplateDialog, setOpenCreateTemplateDialog] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
      <ModalTitle onClose={onClose} title={<Trans>Crear reporte</Trans>} />
      <ModalContent topDivider>
        <FormFirstStepReportCreation initialValues={initialValues}>
          {({ formState, submit, submitResult }) => {
            return (
              <Box sx={{ display: 'flex', flexDirection: 'row-reverse', flex: 1, gap: 2 }}>
                <Button
                  sx={{ width: 'fit-content', alignSelf: 'flex-end' }}
                  onClick={() => {
                    submit();
                    setOpenConfirmationDialog(true);
                  }}
                  color="success"
                  variant="contained"
                  disabled={!formState.isValid}
                >
                  <Trans>Crear Reporte</Trans>
                </Button>
                <Button
                  sx={{ width: 'fit-content', alignSelf: 'flex-end' }}
                  onClick={() => {
                    submit();
                    setOpenCreateTemplateDialog(true);
                  }}
                  color="success"
                  variant="outlined"
                  disabled={!formState.isValid}
                >
                  <Trans>Crear Plantilla</Trans>
                </Button>
                <Button
                  sx={{ width: 'fit-content', alignSelf: 'flex-end' }}
                  onClick={() => {
                    onClose();
                  }}
                  color="info"
                  variant="outlined"
                >
                  <Trans>Cancelar</Trans>
                </Button>

                <CreateReportTemplateDialog
                  open={openCreateTemplateDialog}
                  onClose={() => setOpenCreateTemplateDialog(false)}
                  formReportCreation={submitResult}
                />
                <CreateReportDialog
                  open={openConfirmationDialog}
                  onClose={() => setOpenConfirmationDialog(false)}
                  formReportCreation={submitResult}
                />
              </Box>
            );
          }}
        </FormFirstStepReportCreation>
      </ModalContent>
    </Dialog>
  );
};
